import React from 'react';
import { Box, Typography } from '@mui/material';
import theme from '../../theme';

const PostpopRecommendationNote = ({
  comment,
  label = '앨범 노트',
  lineClamp = { xs: 2, md: 2 },
  sx = {},
  labelSx = {},
  commentSx = {},
}) => {
  if (!comment) return null;

  const shouldClamp = lineClamp && lineClamp !== 'unset';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 0.75, md: 0.875 },
        minWidth: 0,
        ...sx,
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          width: 3,
          flexShrink: 0,
          alignSelf: 'stretch',
          backgroundColor: theme.palette.secondary.main,
        }}
      />
      <Box
        sx={{
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          transform: { xs: 'translateY(2px)', md: 'translateY(2px)' },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 11, md: 12 },
            fontWeight: 700,
            lineHeight: 1,
            color: theme.palette.black[4],
            mb: { xs: 0.625, md: 0.75 },
            ...labelSx,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            ...(shouldClamp
              ? {
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: lineClamp,
                  overflow: 'hidden',
                }
              : {}),
            fontSize: { xs: 14, md: 14, lg: 15 },
            fontWeight: 600,
            fontStyle: 'italic',
            lineHeight: 1.48,
            color: theme.palette.black[6],
            pb: '0.08em',
            pr: '0.08em',
            ...commentSx,
          }}
        >
          {comment}
        </Typography>
      </Box>
    </Box>
  );
};

export default PostpopRecommendationNote;
